import { render, staticRenderFns } from "./TestOrderResult.vue?vue&type=template&id=606f8b2c&"
import script from "./TestOrderResult.vue?vue&type=script&lang=js&"
export * from "./TestOrderResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports